import { createIconSet } from '@expo/vector-icons';
import glyphMap from '~/../assets/fonts/Octicons/unicodesMap.json';
export default createIconSet(glyphMap, 'Octicons', require('~/../assets/fonts/Octicons/Octicons.ttf'));
